export default {"src":"/_next/static/media/goat-spins-text-banner-2-mob.be1ba7d1.svg","height":253,"width":262,"blurWidth":0,"blurHeight":0};